import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Generic drag-and-drop list reordering. On drop, PATCH reorder URL with new position.
// Usage:
//   <div data-controller="sortable-list">
//     <div data-sortable-id="1" data-reorder-url="/path/to/reorder/1">
//       <span data-sortable-list-handle>⠿</span>
//       ...
//     </div>
//   </div>
export default class extends Controller {
  connect() {
    Sortable.create(this.element, {
      animation: 150,
      ghostClass: "opacity-40",
      handle: "[data-sortable-list-handle]",
      onEnd: (evt) => this.onItemMoved(evt),
    })
  }

  async onItemMoved(evt) {
    const el = evt.item
    const reorderUrl = el.dataset.reorderUrl
    if (!reorderUrl) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const url = new URL(reorderUrl, window.location.origin)
    url.searchParams.set("position", evt.newIndex)

    try {
      const res = await fetch(url.toString(), {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          Accept: "application/json",
        },
      })

      if (!res.ok) throw new Error("Failed to reorder")
    } catch (err) {
      const parent = evt.from
      const children = Array.from(parent.children).filter((c) => c !== evt.item)
      const target = children[evt.oldIndex]
      target ? parent.insertBefore(evt.item, target) : parent.appendChild(evt.item)
    }
  }
}
